import { useSlate } from 'slate-react';
import { ToolbarDropdown } from '../../../../../RichTextEditorV2/Toolbar/components/ToolbarDropdown';
import { FONT_FAMILY_TOOL_OPTIONS } from './constants/FontFamilyTool.constants';
import { useStyles } from './FontFamilyTool.styles';

export const FontFamilyTool = () => {
  const editor = useSlate();
  const classes = useStyles();

  return (
    <ToolbarDropdown
      editor={editor}
      options={FONT_FAMILY_TOOL_OPTIONS}
      inputBaseRootClassName={classes.root}
      selectClassName={classes.root}
      format="fontFamily"
    />
  );
};
